import { RightOutlined } from '@ant-design/icons';
import { ReportStatusChip } from '@/features/report-list';
import type { ReportListStatus } from '@/models/report';
import type { DraftGroup } from '../../types/historyEvent';
import { formatTimestamp } from '../../utils/formatters';
import { TimelineItem } from '../TimelineItem';
import styles from './DraftGroupItem.module.css';

interface DraftGroupItemProps {
  group: DraftGroup;
  isExpanded: boolean;
  onToggle: () => void;
  selectedEventId: string | null;
  onSelectEvent: (id: string) => void;
}

export default function DraftGroupItem({
  group,
  isExpanded,
  onToggle,
  selectedEventId,
  onSelectEvent,
}: DraftGroupItemProps) {
  const { latestEvent, events } = group;

  return (
    <div>
      <button
        type="button"
        className={styles.header}
        onClick={onToggle}
        aria-expanded={isExpanded}
        aria-label={`Draft group with ${events.length} edits`}
      >
        <div className={styles.nodeCol}>
          <span className={styles.node} />
        </div>

        <div className={styles.content}>
          <div className={styles.titleRow}>
            <span className={styles.label}>Draft Saved</span>
            <StatusChips tags={latestEvent.statusTags} />
            <span className={styles.countBadge}>
              {events.length} edits
              <span
                className={`${styles.chevron} ${isExpanded ? styles.chevronExpanded : ''}`}
              >
                <RightOutlined />
              </span>
            </span>
          </div>

          <span className={styles.timestamp}>
            {formatTimestamp(latestEvent.timestamp)}
          </span>
        </div>
      </button>

      <div
        className={`${styles.children} ${isExpanded ? styles.childrenExpanded : ''}`}
      >
        <div className={styles.childrenInner}>
          {events.map((event) => (
            <TimelineItem
              key={event.id}
              event={event}
              isSelected={selectedEventId === event.id}
              onSelect={onSelectEvent}
            />
          ))}
        </div>
      </div>
    </div>
  );
}

function StatusChips({ tags }: { tags: string[] }) {
  if (!tags.length) return null;
  return (
    <>
      {tags.map((tag) => (
        <ReportStatusChip key={tag} status={tag as ReportListStatus} />
      ))}
    </>
  );
}
